import { QuoteRequestLineItemStatus } from '@luminovo/api-contracts';
import { colorSystem, StatusChip } from '@luminovo/design-system';

import { formatQuoteRequestLineItemStatus } from '../../formatters/formatQuoteRequestLineItemStatus';

export function QuoteRequestLineItemStatusChip({
    quoteRequestLineItemStatus,
    perspective = 'sender',
}: {
    quoteRequestLineItemStatus: QuoteRequestLineItemStatus;
    perspective?: 'sender' | 'receiver';
}) {
    return (
        <StatusChip
            color={getQuoteRequestLineItemStatusColor(quoteRequestLineItemStatus)}
            label={formatQuoteRequestLineItemStatus(quoteRequestLineItemStatus, { perspective })}
        />
    );
}

export function getQuoteRequestLineItemStatusColor(
    quoteRequestLineItemStatus: QuoteRequestLineItemStatus,
): keyof typeof colorSystem {
    switch (quoteRequestLineItemStatus) {
        case QuoteRequestLineItemStatus.NotSent:
        case QuoteRequestLineItemStatus.UnsolicitedOffer:
            return 'neutral';
        case QuoteRequestLineItemStatus.Sent:
            return 'blue';
        case QuoteRequestLineItemStatus.Overdue:
            return 'red';
        case QuoteRequestLineItemStatus.Received:
            return 'green';
        case QuoteRequestLineItemStatus.NoBid:
            return 'violet';
        case QuoteRequestLineItemStatus.Discarded:
            return 'yellow';
        case QuoteRequestLineItemStatus.Awarded:
            return 'primary';
    }
}
